import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpBackend } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenManagementService {
  private serviceUrl : string = "";
  private token : string = "";
  private http: HttpClient;

  constructor(private httpBackend:HttpBackend) { 
    this.http = new HttpClient(httpBackend);
  }

  getNewToken():Observable<any>{   
  
    const body = new HttpParams()
    .set('grant_type','password')
    .set('username',"username")
    .set("password","password");    
    return this.http.post<any>(this.serviceUrl+"/Token",body).pipe(tap(data => JSON.stringify(data)),
    catchError(this.handleError));
  }
 
  private handleError(err: HttpErrorResponse) {

    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${err.error.message}`;
    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
